module.exports = __webpack_public_path__ + "static/media/ico-alert-success.499509fe.svg";